// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc3c2cee","455":"4815f594","977":"e83b2a68"}[chunkId] + ".chunk.js";
};